import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import {  SmsCount } from '../../../_models';
import { AuthenticationService, NotificationService, KeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SmsCountService } from 'src/app/_services/sms-count.service';

@Component({
  selector: 'app-sms-count',
  templateUrl: './sms-count.component.html'
})
export class SmsCountComponent implements OnInit {

  smsCountList: SmsCount[];
  sourceList = [];
  countryList: any = {};
  operatorList = [];
  loading = false;
  processing = false;
  totalItems = 0;
  emptyResult = true;
  exporting = false;
  downloadUrl = '';
  //filter
  filterable = {
    source: null,
    country: null,
    operator: "",
    month: null,
    subscribePrice:0.07,
    unsubscribePrice:0.07,
    reminderPrice:0.07,
    mtChargePrice:0.07,
    mtFreePrice:0.07,
    otpPrice: 0.07,
    realtime: false
  };

  realtimeFlags = {'Realtime': true, 'Offline': false};
  resultName = '';

  selectedCountry = '';

  constructor(private fb: FormBuilder,
    private authSvc: AuthenticationService,
    private keywordSvc: KeywordService,
    private smsCountSvc: SmsCountService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setMonth(dte.getMonth() -1);
    this.filterable.month = dte.toISOString().substring(0, 7);
    this.loadSources();
  }

  search() {
    this.emptyResult = false;
    var month = formatDate(this.filterable.month, 'yyyyMM', 'en');
    this.loadPage(month);
  }

  export() {
    this.exporting = true;
    var month = formatDate(this.filterable.month, 'yyyyMM', 'en');
    let params = {
      month: month,
      source: this.filterable.source.value,
      country: this.filterable.country,
      operator: this.filterable.operator,
      subscribePrice: this.filterable.subscribePrice,
      unsubscribePrice: this.filterable.unsubscribePrice,
      reminderPrice: this.filterable.reminderPrice,
      mtChargePrice: this.filterable.mtChargePrice,
      mtFreePrice: this.filterable.mtFreePrice,
      otpPrice: this.filterable.otpPrice,
    }
    this.smsCountSvc.export(params, this.filterable.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  changeSource(source) {
    if (source) {
      this.countryList = source.subOptions;
      var key = Object.keys(this.countryList)[0];
      var value = this.countryList[key];
      this.selectedCountry = value;
      this.filterable.country = value;
      if(source.value == 7){
        this.filterable.realtime = false;
      }
      this.changeCountry(value);
    }
  }

  changeCountry(country) {
    this.filterable.operator = '';
    this.filterable.country = country;
    this.selectedCountry = country;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country, "reminder").subscribe(data => {
        this.operatorList = Object.keys(data.data);
        this.filterable.operator = this.operatorList[0];
      });
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources("reminder").pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      this.filterable.source = data.data[0];
      this.countryList = data.data[0].subOptions;
      var key = Object.keys(data.data[0].subOptions)[0];
      var value = data.data[0].subOptions[key];
      let tempObj = {
        key: key,
        value: value
      };
      this.selectedCountry = value;
      this.filterable.country = value;
      this.changeCountry(this.filterable.country);
    });
  }

  private loadPage(month) {
    this.loading = true;
    this.smsCountList = [];
    this.totalItems = 0;
    let params = {
      month: month,
      source: this.filterable.source.value,
      country: this.filterable.country,
      operator: this.filterable.operator,
      subscribePrice: this.filterable.subscribePrice,
      unsubscribePrice: this.filterable.unsubscribePrice,
      reminderPrice: this.filterable.reminderPrice,
      mtChargePrice: this.filterable.mtChargePrice,
      mtFreePrice: this.filterable.mtFreePrice,
      otpPrice: this.filterable.otpPrice,
    }

    // get page of items from api
    if(this.filterable.source.value == 7){
      this.filterable.realtime = false;
    }
    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';

    this.smsCountSvc.getAll(params, this.filterable.realtime).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.smsCountList = data.data;
        this.totalItems = data.data.length;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report", "Empty Result");
      }
    });
  }

}
